// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoStateInput_container__1hZf3","inputTitle":"TwoStateInput_inputTitle__2LSPS","state":"TwoStateInput_state__2P_sz"};